import React from 'react';
import { connect } from 'react-redux';
import Col from 'react-bootstrap/Col';
import _get from 'lodash/get';
import properties from '../../../modules/ajio-util/properties';
import { hideModal } from '../../../actions/modal';
import EditSizeUpdate from './EditSizeUpdate';
import { fetchSizeAndBrandSize } from '../../../utils/StandardSizeUtils';

export default class ProductSizeUpdation extends React.Component {
  constructor(props) {
    super(props);
    this.textContent = {
      selectSize: 'Select size',
      exchangeWith: 'Exchange with'
    };
  }

  render() {
    const {
      code,
      variantOptions = [],
      pageType = '',
      sizeToolTip = '',
      setSelectedSizeValue,
      size = '',
      sizeDetails: { baseOptions = [] } = {},
      updateData = '',
      data = {},
      pageName = '',
      selectSizeErr = '',
      newSizeRevampFlag,
      showBrandSizeFlag,
      hideSizes,
      newDesignLuxe,
      deliveryChoices = [],
      enableMultiSellerSla = false
    } = this.props;
    let sizeVariant;
    let variantOptionQualifiers;

    baseOptions.map((variant, i) => {
      if (variant.variantType === 'FnlSizeVariant') {
        sizeVariant = variant.options;
        variantOptionQualifiers = variant.selected.variantOptionQualifiers;
      }
    });

    if (sizeVariant === undefined) {
      sizeVariant = variantOptions;
    }

    let isSelectedSizeIsOOS = false;
    if (sizeVariant && sizeVariant.length) {
      const stock = sizeVariant.find(({ code: sizeCode }) => sizeCode === code) || {};
      const { stock: { stockLevel = '' } = {} } = stock;
      if (stockLevel === 0) {
        isSelectedSizeIsOOS = true;
      }
    }

    let isProductIsOOS = false;
    if (sizeVariant && sizeVariant.length) {
      isProductIsOOS = sizeVariant.every(({ stock: { stockLevel } }) => stockLevel === 0);
    }
    const { sizeType = '' } = fetchSizeAndBrandSize(variantOptionQualifiers, newSizeRevampFlag);
    return (
      <div className={`${newDesignLuxe ? 'luxe-newdesign' : ''} cart-size-section`}>
        {!hideSizes ? (
          <p className="header-label">
            {pageName === 'ReturnExchange' ? (
              this.textContent.exchangeWith
            ) : (
              <span>
                <span role='heading' aria-level={2}>{this.textContent.selectSize}</span>
                <span className="size-format">{sizeType ? ` (${sizeType})` : ''}</span>
              </span>
            )}
          </p>
        ) : (
          ''
        )}
        {!hideSizes && pageName !== 'ReturnExchange' && isProductIsOOS && (
          <p className="availablily-message">Your size is currently out of stock</p>
        )}
        {!hideSizes && pageName !== 'ReturnExchange' && !isProductIsOOS && isSelectedSizeIsOOS && (
          <p className="availablily-message">Your size is currently out of stock</p>
        )}

        <EditSizeUpdate
          code={code}
          sizeVariantOptions={sizeVariant}
          setSelectedSizeValue={setSelectedSizeValue}
          size={size}
          updateData={updateData}
          sizeToolTip={sizeToolTip}
          pageType={pageType}
          data={data}
          newSizeRevampFlag={newSizeRevampFlag}
          showBrandSizeFlag={showBrandSizeFlag}
          hideSizes={hideSizes}
          newDesignLuxe={newDesignLuxe}
          deliveryChoices={deliveryChoices}
          enableMultiSellerSla={enableMultiSellerSla}
        />
        {selectSizeErr && <div className="error-msg">{selectSizeErr}</div>}
      </div>
    );
  }
}
